import {
  Component,
  OnInit,
  Input,
  OnChanges,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';

import { Subject } from 'rxjs';
import { debounceTime ,  distinctUntilChanged ,  filter ,  switchMap } from 'rxjs/operators';

import { ProductService } from '../../../my-products/shared/product.service';
import {Product} from '../../../models/product.model';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  products: Product[];
  term$ = new Subject<string>();
  @Input() showSearch: boolean = true;
  @Output() onHideSearch = new EventEmitter<boolean>();
  @ViewChild('searchInput') searchInput!: ElementRef;

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.term$
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        filter((term) => term.length > 0),
        switchMap((term) => this.search(term))
      )
      .subscribe((results) => {
        this.products = results;
      });
  }

  public search(term: string) {
    return this.productService.findProducts(term);
  }

  public onSearchInput(event) {
    let term = event.target.value;
    if (term.length > 0) {
      term = term.charAt(0).toUpperCase() + term.slice(1);
      this.term$.next(term);
    } else {
      this.products = [];
      this.term$.next('');
    }
  }
  public onCloseSearch(inputElement ?: HTMLInputElement) {
    this.showSearch = false;
    this.products = [];
    inputElement.value = '';
    this.onHideSearch.emit(false);
    inputElement.value = ''; // Efface le champ de saisie
    this.term$.next('');
    this.products = []
  }




}
